<template>
  <section class="about-area">
    <div class="container container-xs" v-if="localProvider">
      <div class="yunus-logo">
        <img
          :src="localProvider.logo"
          style="height:150px; weight:150px;"
          alt=""
        />
      </div>
      <div class="about-heading">
        <h2>
          {{ localProvider.name }}
          <span class="d-block d-md-inline"
            >Founded {{ localProvider.year_founded }}</span
          >
        </h2>
      </div>
      <div class="row">
        <main class="col-lg-8 mb-5">
          <div class="about-describe">
            <div class="row">
              <div class="col-lg-12">
                <a class="visit" :href="localProvider.url"
                  ><i class="fa fa-link" aria-hidden="true"></i> Visit
                  website</a
                >
              </div>
              <div class="col-lg-12">
                <div class="about-social d-vlock">
                  <ul class="mt-3">
                    <li v-for="social_media in social_medias">
                      <a :href="social_media.url" target="_blank">
                        <i :class="social_media.symbolClass"></i>
                      </a>
                    </li>
                    <div class="clearfix"></div>
                  </ul>
                </div>
              </div>
              <div class="col-lg-12">
                <p v-if="!showMoreDesc" class="my-2" v-html="shortDesc"></p>
                <p v-else v-html="longDesc" class="my-2"></p>
                <a
                  v-if="displayShowOption && !showMoreDesc"
                  class="read-more"
                  @click="toggleShowState"
                  >See More.</a
                >
                <a
                  v-if="displayShowOption && showMoreDesc"
                  class="read-more"
                  @click="toggleShowState"
                  >See Less.</a
                >
              </div>
              <div class="col-lg-12">
                <div class="about-list">
                  <ul class="bullet-list column-2">
                    <li v-for="capType in capitalTypeList">{{ capType }}</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="about-contact">
            <h3>sectors</h3>
            <p>The funder is active in the following sectors:</p>

            <sector-chart
              v-if="localProvider.provider_sectors"
              :provider="localProvider"
            />

            <h3>Countries</h3>
            <p>
              The funder is active in the following countries (darker shade
              indicates higher likelihood of being active):
            </p>
            <div class="map" v-if="localProvider.provider_countries">
              <p><country-chart :provider="localProvider" /></p>
            </div>
            <div class="row my-4">
              <div class="col-12 col-sm-6">
                <h3 class="text-dark">Languages</h3>
                <ul class="bullet-list">
                  <li v-for="lang in languages">{{ lang }}</li>
                </ul>
              </div>
              <div class="col-12 col-sm-6">
                <h3 class="text-dark">Currencies</h3>
                <ul class="bullet-list">
                  <li v-for="currency in currencies">{{ currency }}</li>
                </ul>
              </div>
            </div>
            <div
              v-if="
                localProvider.relationships.length > 0 &&
                  this.companies.length > 0
              "
            >
              <h3 class="text-dark">Investments</h3>
              <p>
                These are the companies this investor has funded:
              </p>
              <div v-for="(deal, index) in localProvider.relationships">
                <div
                  v-if="index < 3 && !showMoreDeals"
                  style="padding: 30px 15px; border-top: 1px solid #006d2a;"
                >
                  <deal-card :deal="deal" />
                </div>
                <div
                  v-if="showMoreDeals"
                  style="padding: 30px 15px; border-top: 1px solid #006d2a;"
                >
                  <deal-card :deal="deal" />
                </div>
              </div>
              <div
                v-if="localProvider.relationships.length > 3"
                style="padding: 30px 15px; border-top: 1px solid #006d2a;"
              >
                <div class="row" style="border-left: 0px solid">
                  <a
                    v-if="!showMoreDeals"
                    class="read-more col-12 col-md-12 col-lg-12"
                    style="text-align: center;"
                    @click="toggleShowDealState"
                    >See More Deals</a
                  >
                  <a
                    v-if="showMoreDeals"
                    class="read-more col-12 col-md-12 col-lg-12"
                    style="text-align: center;"
                    @click="toggleShowDealState"
                    >See Less Deals</a
                  >
                </div>
              </div>
            </div>
          </div>
        </main>
        <aside class="col-lg-4">
          <div
            v-if="
              office ||
                (localProvider.email && localProvider.email.length > 0) ||
                (localProvider.phone_number &&
                  localProvider.phone_number.length > 0) ||
                (localProvider.contacts && localProvider.contacts.length > 0)
            "
            class="about-contact contact-border"
          >
            <h3
              v-if="
                (localProvider.email && localProvider.email.length > 0) ||
                  (localProvider.phone_number &&
                    localProvider.phone_number.length > 0)
              "
            >
              contact
            </h3>
            <div v-if="office" class="address">
              <p style="margin-bottom: 1px;">
                <i class="fa fa-map-marker"></i> {{ office.address_line_1 }}
              </p>
              <p style="margin-bottom: 1px;" v-if="office.address_line_2">
                {{ office.address_line_2 }}
              </p>
              <p style="margin-bottom: 1px;" v-if="office.address_line_3">
                {{ office.address_line_3 }}
              </p>
              <p style="margin-bottom: 1px;" v-if="office.city">
                {{ office.city }}
              </p>
            </div>
            <b v-if="localProvider.email && localProvider.email.length > 0">{{
              localProvider.email
            }}</b>
            <br v-if="localProvider.email && localProvider.email.length > 0" />
            {{ localProvider.phone_number }}
            <div class="map my-4" v-if="office.country">
              <country-map :provider="localProvider" />
            </div>
            <h3 v-if="contactsExist" class="text-dark">
              Team
            </h3>
            <div v-if="contactsExist" style="padding-bottom: 20px;">
              <div
                v-for="contact in localProvider.contacts"
                v-if="contact.name != null"
              >
                <a
                  v-if="contact.linkedin"
                  :href="contact.linkedin"
                  target="_blank"
                >
                  <div
                    class="contact-card clickable"
                    :class="contact.linkedin ? 'has-link' : ''"
                  >
                    <contact-card :contact="contact" />
                  </div>
                </a>
                <div
                  v-else
                  class="contact-card"
                  :class="contact.linkedin ? 'has-link clickable' : ''"
                >
                  <contact-card :contact="contact" />
                </div>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </div>
    <div v-else class="container container-xs" style="height: 300px;">
      <h2>
        Loading...
      </h2>
    </div>
    <div class="container container-xs" v-if="localProvider">
      <div class="row">
        <p class="my-5 py-lg-5">
          <a href="#" class="back-link">
            <router-link :to="{ name: 'Index' }" class="back-link">
              <i class="fa fa-angle-left text-success" aria-hidden="true"></i>
              Back to directory
            </router-link>
          </a>
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import slugify from "slugify";

import helper from "../helper.js";

import CountryChart from "../elements/charts/CountryChart.vue";
import SectorChart from "../elements/charts/SectorChart.vue";
import CountryMap from "../elements/charts/CountryMap.vue";
import DealCard from "../elements/DealCard.vue";
import ContactCard from "../elements/ProviderContactCard.vue";

export default {
  name: "Profile",
  components: {
    "country-chart": CountryChart,
    "sector-chart": SectorChart,
    "country-map": CountryMap,
    "deal-card": DealCard,
    "contact-card": ContactCard
  },
  data() {
    return {
      urlSlugName: this.$route.params.providerName,
      showMoreDesc: false,
      showMoreDeals: false
    };
  },
  computed: {
    ...mapGetters(["results", "providerList", "provider", "companies"]),
    contactsExist: function() {
      return this.localProvider.contacts.some(function(contact) {
        return contact.name != null;
      });
    },
    localProvider: function() {
      if (this.isProviderInUrl(this.provider, this.urlSlugName)) {
        return this.provider;
      } else {
        return undefined;
      }
    },
    office: function() {
      if (this.localProvider.offices == null) {
        return false;
      }
      var office = false;
      if (this.localProvider.offices.length > 0) {
        office = this.localProvider.offices[0];
      }
      return office;
    },
    contact: function() {
      if (this.localProvider.contacts == null) {
        return false;
      }
      var contact = false;
      if (this.localProvider.contacts.length > 0) {
        contact = this.localProvider.contacts[0];
      }
      return contact;
    },
    displayShowOption: function() {
      return this.provider.description.length > 150;
    },
    shortDesc: function() {
      if (!this.displayShowOption) {
        return this.longDesc;
      }
      return `${this.formatDesc(
        this.provider.description.replace().substring(0, 150)
      )}...`;
    },
    longDesc: function() {
      return `${this.formatDesc(this.provider.description)}`;
    },
    capitalTypeList: function() {
      if (this.provider.provider_capital_types == null) {
        return [];
      }
      var capitalTypes = this.provider.provider_capital_types
        .filter(capitalType => {
          return capitalType.capital_type != null;
        })
        .map(capitalType => {
          return capitalType.capital_type.name;
        });
      return capitalTypes;
    },
    languages: function() {
      if (this.provider.provider_languages == null) {
        return [];
      }
      return this.localProvider.provider_languages.map(lang => {
        return lang.language.name;
      });
    },
    currencies: function() {
      if (this.provider.provider_currencies == null) {
        return [];
      }
      return this.localProvider.provider_currencies.map(currency => {
        return currency.currency.name;
      });
    },
    social_medias: function() {
      if (this.localProvider.provider_social_medias == null) {
        return [];
      }
      var nameToSymbolMap = {
        Facebook: "fa fa-facebook",
        Twitter: "fa fa-twitter",
        LinkedIn: "fa fa-linkedin",
        YouTube: "fa fa-youtube-play",
        Instagram: "fa fa-instagram"
      };
      return this.localProvider.provider_social_medias.map(social => {
        return {
          name: social.social_media.name,
          url: social.url,
          symbolClass: nameToSymbolMap[social.social_media.name]
        };
      });
    }
  },
  methods: {
    ...mapMutations({
      setProvider: "setProvider"
    }),
    ...mapActions(["fetchProviderById"]),
    isProviderInUrl(provider, slug) {
      if (provider.hasOwnProperty("id")) {
        return slugify(provider.name, { lower: true }) == slug;
      } else {
        return false;
      }
    },
    formatDesc(str) {
      return helper.formatDesc(str);
    },
    toggleShowState() {
      this.showMoreDesc = !this.showMoreDesc;
      this.requestShowNotNav = true;
    },
    toggleShowDealState() {
      this.showMoreDeals = !this.showMoreDeals;
    }
  },
  created() {
    // first check results to see if we already have provider
    var selectedProvider = this.results.find(provider => {
      return this.isProviderInUrl(provider, this.urlSlugName);
    });
    if (selectedProvider) {
      this.setProvider(selectedProvider);
    }

    // next we index it from providerList and fetch by id
    selectedProvider = this.providerList.find(provider => {
      return this.isProviderInUrl(provider, this.urlSlugName);
    });

    //if we find provider id we send api request else we do so in the providerList Watch once the results are in.
    if (selectedProvider) {
      this.fetchProviderById({ provider_id: selectedProvider.id });
    }
  },
  watch: {
    providerList(newValue, oldValue) {
      var selectedProvider = newValue.find(provider => {
        return this.isProviderInUrl(provider, this.urlSlugName);
      });
      this.fetchProviderById({ provider_id: selectedProvider.id });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.contact-card {
  padding: 30px 15px;
  border-top: 1px solid #006d2a;
}

.has-link:hover {
  background: #deece3;
  transition: 0.3s;
}
</style>



// WEBPACK FOOTER //
// src/components/Profile.vue